import React from 'react'
import {withState} from 'recompose'
import styled from 'styled-components'
import BlueArrow from '../static/blueArr.svg'
import GrayArrow from '../static/grayArr.svg'

const Container = styled.div`
  position: relative;
  height: 32px;
  font-size: 16px;
  background: #173DB0;
  ${props => props.theme === 'mobile-search'
  && 'height: 52px;'
  }
`

const OnTop = styled.div`
  padding-top: 0px;
  padding-left: 8px;
  position: relative;
  width: 100%;
  height: 100%;
  color: ${props =>
  props.theme === 'search' || props.theme === 'mobile-search' || props.theme === 'mobile-nav'
    ? 'white'
    : '#173DB0'
  };
  background: ${props =>
  props.theme === 'search' || props.theme === 'mobile-search'
    ? '#173DB0'
    : props.theme === 'mobile-nav' ? 'rgb(51,78,251)' : 'white'
  };

  ${props => props.theme === 'mobile-search'
  && 'padding: 17px 0 10px 18px;'
  }

  ${props => props.theme === 'mobile-nav'
  && 'padding: 0;'
  }
  ${props => props.theme === 'mobile-nav'
  && 'font-size: 14px;'
  }
  
  & > img {
    position: absolute;
    top: 3px;
    right: 20px;

    ${props => props.theme === 'mobile-nav'
  && ' top: 5px; right: -15px;'
  }
  }
`

const Dropdown = styled.select`
  &[disabled] { pointer-events: none; }
  position: absolute;
  left: 0;
  top: 0;
  background: white;
  color: black;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  z-index: 100;
`

const Select = ({children, value, onChange, label, hover, setHover, disabled, style, imgNotFixed, theme}) => {
  return (
    <Container
      style={style}
      onMouseOver={() => {
        setHover(true)
      }}
      onMouseOut={() => {
        setHover(false)
      }}
      theme={theme}
    >
      <Dropdown
        value={value}
        onChange={onChange}
        disabled={disabled}
        theme={theme}
      >
        {children}
      </Dropdown>
      <OnTop
        hover={hover}
        theme={theme}
      >
        {label}
        {
          <img
            style={{
              display: theme === 'search' && value,
              position: imgNotFixed && 'static',
              paddingLeft: imgNotFixed && 15,
              paddingTop: theme === 'mobile-search' && 20,
              paddingRight: theme === 'mobile-search' && 5,
            }}
            src={(theme === 'search' || theme === 'mobile-search' || theme === 'mobile-nav') ? GrayArrow : BlueArrow}
          />
        }
      </OnTop>
    </Container>
  )
}

export default withState('hover', 'setHover', false)(Select)



// WEBPACK FOOTER //
// ./src/basic/select.js